import ITextValue from 'types/textValue';

export const RunOvernightOptions: ITextValue[] = [
  { text: 'Yes', value: 'true' },
  { text: 'No', value: 'false' },
];
